// 登記取得専用画面（propertyCodeAcquisition）のルート定義。
// container.tsx/presenter.tsx を使わず、本ファイル（routes）に集約する（styleguide 準拠）。
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import { PropertyCodeAcquisition } from "./PropertyCodeAcquisition";

export const PropertyCodeAcquisitionRoutes: React.FC = () => {
  // 親ルートが `/datalens/picturerequest/*` でワイルドカードを許すため、想定外サブパスでも
  // 何もマッチせず空白画面になることがある。その保険としてフォールバックを置く。
  const { search } = useLocation();

  return (
    <Routes>
      <Route path="" element={<PropertyCodeAcquisition />} />
      {/* 想定外サブパス（/datalens/picturerequest/xxx）は画面本体へリダイレクトする。
          物件コード（?code=）を必要とする画面のため、クエリ文字列を保持したまま戻す。 */}
      <Route
        path="*"
        element={<Navigate to={{ pathname: "", search }} replace />}
      />
    </Routes>
  );
};
